import { TranslateParser } from '@ngx-translate/core';

import { SharedTranslateParser } from './shared-translate-parser';

export const createTranslateParser = (): TranslateParser => {
  return new SharedTranslateParser();
};
